import { render, staticRenderFns } from "./AppNavbar1.vue?vue&type=template&id=a155b794"
import script from "./AppNavbar1.vue?vue&type=script&lang=ts"
export * from "./AppNavbar1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports